module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audit_log_icons/people-check-426b6ed929ea0b937c1c966fd4f4d086.svg";